function initContestJudgeEdit() {
  // Генерация ссылки для судьи будет платной функцией
  const addJudgeLinkButton = document.querySelector('.add-judge-invite-link');

  if (!addJudgeLinkButton) {
    return;
  }

  addJudgeLinkButton.addEventListener('click', async function (e) {
    e.preventDefault();

    const modalSelector = '#paid-settings-modal[data-event-source-id="add-judge-invite-link"]';
    const paidSettingsModal = document.querySelector(modalSelector);

    if (!paidSettingsModal) {
      return;
    }

    const url = paidSettingsModal.getAttribute('data-check-contest-paid-url');

    const response = await fetch(url);
    const result = await response.json();

    if (result.status === 'success') {
      const form = e.target.closest('form');
      form.submit();
      return;
    } else {
      const overlay = $('#overlay');
      overlay.addClass('cabinet-contest-modal');
      overlay.fadeIn();
      paidSettingsModal.classList.add('active');

      return false;
    }
  });
}

export { initContestJudgeEdit }